import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
export function FinalSection() {
  return <section className="bg-ivory px-6 py-24 sm:py-32" data-id="element-69" data-mp="3c1u7drghyfaf">
      <div className="mx-auto max-w-2xl text-center" data-id="element-70" data-mp="2y3mcrq6xnq2f">
        <Reveal data-id="element-71" data-mp="2y2ujwn4q06fu">
          <div className="rule-gold" aria-hidden="true" data-id="element-72" data-mp="2y5gn6akkvzs9">
            <span className="text-xs text-gold" data-id="element-73" data-mp="331e6mpr51m99">✦</span>
          </div>

          <h2 className="mt-10 font-serif text-[1.9rem] font-light leading-[1.2] text-ink sm:text-[2.75rem]" data-id="element-74" data-mp="2odsyuijbiyv0">
            Quizás no necesitas convertirte en otra mujer.
            <br data-id="element-75" data-mp="2t641vu9cv0rs" />
            <em className="not-italic text-gold-dark" data-id="element-76" data-mp="2fcut9vt8ejab">
              Quizás necesitas volver a recordar quién eres.
            </em>
          </h2>
        </Reveal>

        <Reveal delay={0.12} data-id="element-77" data-mp="2jepu6z792unk">
          <div className="mt-10 space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-[19px]" data-id="element-78" data-mp="25eosxin2pl7k">
            <p data-id="element-79" data-mp="2adryd46yttg2">
              La mujer que estás buscando no está en algún lugar de tu futuro.
            </p>
            <p data-id="element-80" data-mp="2wdlkimjuh5sq">
              Hay una versión de ti que ya sabe que es momento de avanzar.
              Quizás lo único que necesita es que finalmente la escuches.
            </p>
            <p className="font-serif text-xl italic text-ink sm:text-2xl" data-id="element-81" data-mp="35et561tfu84c">
              Dale permiso de despertar.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-82" data-mp="30g882b9hg4k4">
          <div className="mt-11 flex flex-col items-center gap-5" data-id="element-83" data-mp="30dvm7n0lta1s">
            <CtaButton targetId="test" size="lg" pixelEvent="StartTrial" pixelParams={{
            content_name: 'Final — Descubrir mi bloqueo'
          }} data-id="element-84" data-mp="2cqnnxp1lf199">
              Quiero descubrir mi bloqueo
            </CtaButton>
            <p className="max-w-sm text-[14px] leading-relaxed text-ink-muted" data-id="element-85" data-mp="2ho5wvffm1gh9">
              La Herradura Dorada · Una conversación contigo misma que puede
              abrir una nueva perspectiva.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}